import { jsx as _jsx } from "react/jsx-runtime";
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { PopUpView } from './PopUpView';
export const ErrorPopUpView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.errorPopUp
})(({ visible, interactions, title, description, onDismiss, localization }) => {
    return (_jsx(PopUpView, { visible: visible, title: title || (localization === null || localization === void 0 ? void 0 : localization.title) || (localization === null || localization === void 0 ? void 0 : localization.uh_oh) || 'Uh oh!', description: description, interactions: interactions, onDismiss: onDismiss }));
});
